/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MeasureSpecification } from "./MeasureSpecification";
import {
  MeasureSpecificationFromJSON,
  MeasureSpecificationFromJSONTyped,
  MeasureSpecificationToJSON,
  MeasureSpecificationToJSONTyped,
} from "./MeasureSpecification";
import type { StructureControlActionTypeEnum } from "./StructureControlActionTypeEnum";
import {
  StructureControlActionTypeEnumFromJSON,
  StructureControlActionTypeEnumFromJSONTyped,
  StructureControlActionTypeEnumToJSON,
  StructureControlActionTypeEnumToJSONTyped,
} from "./StructureControlActionTypeEnum";
import type { StructureTypeEnum } from "./StructureTypeEnum";
import {
  StructureTypeEnumFromJSON,
  StructureTypeEnumFromJSONTyped,
  StructureTypeEnumToJSON,
  StructureTypeEnumToJSONTyped,
} from "./StructureTypeEnum";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface PatchedMemoryStructureControl
 */
export interface PatchedMemoryStructureControl {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly url?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset?: number;
  /**
   * event duration in seconds. -9999 is the 'infinite duration' value (only allowed in conjunction with infinite simulations
   */
  duration?: number | null;
  /**
   *
   */
  measureSpecification?: MeasureSpecification;
  /**
   *
   */
  structureId?: number | null;
  /**
   *
   */
  structureType?: StructureTypeEnum;
  /**
   *
   */
  type?: StructureControlActionTypeEnum;
  /**
   * list containing a single action values, e.g. [*action_value*]. For type set_discharge_coefficients two action values need to be provided, e.g. [*action_value*, *action_value*].
   */
  value?: Array<number>;
  /**
   *
   */
  readonly state?: EventStateEnum;
  /**
   *
   */
  readonly stateDetail?: any | null;
  /**
   *
   */
  gridId?: number | null;
  /**
   *
   */
  readonly uid?: string;
  /**
   * e.g. 0.3
   */
  upperThreshold?: number | null;
  /**
   * e.g. 0.3
   */
  lowerThreshold?: number | null;
  /**
   * when True the initial state of the target is active
   */
  isActive?: boolean;
  /**
   * when True the target will become active when the lower threshold has been reached
   */
  isInverse?: boolean;
}

/**
 * Check if a given object implements the PatchedMemoryStructureControl interface.
 */
export function instanceOfPatchedMemoryStructureControl(
  value: object
): value is PatchedMemoryStructureControl {
  return true;
}

export function PatchedMemoryStructureControlFromJSON(json: any): PatchedMemoryStructureControl {
  return PatchedMemoryStructureControlFromJSONTyped(json, false);
}

export function PatchedMemoryStructureControlFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedMemoryStructureControl {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    url: json["url"] == null ? undefined : json["url"],
    offset: json["offset"] == null ? undefined : json["offset"],
    duration:
      json["duration"] === undefined
        ? undefined
        : json["duration"] === null
        ? null
        : json["duration"],
    measureSpecification:
      json["measure_specification"] == null
        ? undefined
        : MeasureSpecificationFromJSON(json["measure_specification"]),
    structureId:
      json["structure_id"] === undefined
        ? undefined
        : json["structure_id"] === null
        ? null
        : json["structure_id"],
    structureType:
      json["structure_type"] == null
        ? undefined
        : StructureTypeEnumFromJSON(json["structure_type"]),
    type: json["type"] == null ? undefined : StructureControlActionTypeEnumFromJSON(json["type"]),
    value: json["value"] == null ? undefined : json["value"],
    state: json["state"] == null ? undefined : EventStateEnumFromJSON(json["state"]),
    stateDetail:
      json["state_detail"] === undefined
        ? undefined
        : json["state_detail"] === null
        ? null
        : json["state_detail"],
    gridId:
      json["grid_id"] === undefined ? undefined : json["grid_id"] === null ? null : json["grid_id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    upperThreshold:
      json["upper_threshold"] === undefined
        ? undefined
        : json["upper_threshold"] === null
        ? null
        : json["upper_threshold"],
    lowerThreshold:
      json["lower_threshold"] === undefined
        ? undefined
        : json["lower_threshold"] === null
        ? null
        : json["lower_threshold"],
    isActive: json["is_active"] == null ? undefined : json["is_active"],
    isInverse: json["is_inverse"] == null ? undefined : json["is_inverse"],
  };
}

export function PatchedMemoryStructureControlToJSON(json: any): PatchedMemoryStructureControl {
  return PatchedMemoryStructureControlToJSONTyped(json, false);
}

export function PatchedMemoryStructureControlToJSONTyped(
  value?: Omit<
    PatchedMemoryStructureControl,
    "id" | "url" | "state" | "stateDetail" | "uid"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    duration: value["duration"],
    measure_specification: MeasureSpecificationToJSON(value["measureSpecification"]),
    structure_id: value["structureId"],
    structure_type: StructureTypeEnumToJSON(value["structureType"]),
    type: StructureControlActionTypeEnumToJSON(value["type"]),
    value: value["value"],
    grid_id: value["gridId"],
    upper_threshold: value["upperThreshold"],
    lower_threshold: value["lowerThreshold"],
    is_active: value["isActive"],
    is_inverse: value["isInverse"],
  };
}
